import { render, staticRenderFns } from "./CreateTournament.vue?vue&type=template&id=95c13e74&"
import script from "./CreateTournament.vue?vue&type=script&lang=js&"
export * from "./CreateTournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports